import api from "../../index";

export const GetWalletReportApi = (params) =>
  api.get(`Admin/Get-Wallet-Report?${params}`);
